import { css, html } from "../helpers/webComponents";

const styles: string = css`
    :host{
        height: 100%;
        width: 100%;
        display: flex;
        background-color: rgba(0, 0, 0, 0.6);
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
`;

export class ModalPuzzelComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderPuzzel();
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderPuzzel(): HTMLElement {
        const element: HTMLElement = html`
                <div>
                    <style>
                        ${styles}
                    </style>
                    <div>
                        <game-puzzel></game-puzzel>
                    </div>
                </div>
            `;

        return element;
    }
}
